import { render, staticRenderFns } from "./sudahDitempatkan.vue?vue&type=template&id=3a8edcee"
import script from "./sudahDitempatkan.vue?vue&type=script&lang=js"
export * from "./sudahDitempatkan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports